<div
  [class.progression-steps--center]="stepInfo().isCenterAligned"
  [class.progression-steps--right]="!stepInfo().isCenterAligned"
  class="progression-steps"
>
  <p class="progression-steps__text">{{ currentStepWithPageName() }}</p>
</div>
